import gsap from "gsap";
import {
  Color,
  Group,
  Mesh,
  MeshBasicMaterial,
  Object3d,
  Vector2,
  Vector3
} from 'three';

export default class GridAnimation {

  constructor() { this.playing = false; }

  setLandscapeSizes() {
    if (window.innerWidth > window.innerHeight) {
      let seasons = document.querySelectorAll('.season');
      let h = .2 * window.innerHeight;
      seasons.forEach((item, i) => { item.style.height = h + "px"; });

      let navGridStyle = document.getElementById("nav-grid-style");
      let nt = (window.innerHeight / 2) + (window.innerHeight * .4) + 10;
      navGridStyle.style.top = nt + "px";
      // top: calc(50% + 40vh + 10px);

      // let container = document.getElementById("nav-grid-seasons");
      // container.style.top = (.1 * window.innerHeight) + "px";
    } else {
      let seasons = document.querySelectorAll('.season');
      seasons.forEach((item, i) => { item.style.height = "22vw"; });

      let navGridStyle = document.getElementById("nav-grid-style");
      navGridStyle.style.top = "calc(50% + 45vw)";
      // let container = document.getElementById("nav-grid-seasons");
      // container.style.top = "10vh";
    }
  }

  playAnimation(navGrid) {

    // set the llandscape settings
    this.setLandscapeSizes();
    ///

    this.spanArrays = this.splitLettersForSeasons();

    this.navGrid = navGrid;

    let springEl = document.querySelector(".season:nth-child(1)");
    let summerEl = document.querySelector(".season:nth-child(2)");
    let autumnEl = document.querySelector(".season:nth-child(3)");
    let winterEl = document.querySelector(".season:nth-child(4)");

    let spanArrays = this.spanArrays;

    //---begin
    this.playing = true;
    let tm = gsap.timeline(
        {onComplete : function() { this.playing = false; }.bind(this)});
    this.tm = tm;
    //
    let springTM = this.getSeasonTM(springEl, spanArrays['spring'], 0, 4);
    tm.add(springTM);

    let summerTM = this.getSeasonTM(summerEl, spanArrays['summer'], 4, 8);
    tm.add(summerTM, "<+=1.5");

    let autumnTM = this.getSeasonTM(autumnEl, spanArrays['autumn'], 8, 12);
    tm.add(autumnTM, "<+=1.5");

    let winterTM = this.getSeasonTM(winterEl, spanArrays['winter'], 12, 16);
    tm.add(winterTM, "<+=1.5");

    // traditional
    let tradEl = document.querySelector(".poem-style:nth-child(1)");
    tm.to(tradEl, {opacity : 1, duration : .5, ease : 'sine.inOut'}, "-=.25");
    let arrowLine = document.querySelector("#trad-arrow .arrow-line");
    let arrowHead = document.querySelector("#trad-arrow .arrow-head");
    tm.add("arrow");
    tm.to(arrowHead, {opacity : '1', duration : .25, ease : ' sine.inOut'});
    tm.to(arrowLine,
          {width : '100%', delay : 0, duration : 1, ease : ' sine.inOut'},
          "arrow");

    let modernEl = document.querySelector(".poem-style:nth-child(2)");
    tm.to(modernEl, {opacity : 1, duration : .5, ease : 'sine.inOut'}, "<+=1");

    let gridTm = gsap.timeline();
    for (let x = 0; x < 4; x++) {
      let ngTM = gsap.timeline();
      ngTM.add("col")
      for (let y = 0; y < 4; y++) {
        let index = (x + y * 4);
        ngTM.to(this.navGrid[index].scale, {x : 1, y : 1, z : 1, duration : .5},
                "col");
        ngTM.to(this.navGrid[index].scale,
                {x : .8, y : .8, z : .8, duration : 1}, "col+=.5");
      }
      gridTm.add(ngTM, "<+=.25");
    }

    tm.add(gridTm, "arrow+=1");

    tm.to(tradEl, {opacity : 0, duration : 2, ease : 'sine.inOut'});
    tm.to(modernEl, {opacity : 0, duration : 2, ease : 'sine.inOut'}, "<");

    let haikuInfoButton = document.getElementById("haiku-info-button");
    tm.to(haikuInfoButton, {
      opacity : 1,
      y : -10,
      duration : 1,
      ease : 'sine.inOut',
      onComplete : () => { haikuInfoButton.classList.add("show") }
    });

    // let arrowLine2 = document.querySelector("#mod-arrow .arrow-line");
    // tm.to(arrowLine2, {width : '100%', duration : 1, ease : ' sine.inOut'});
  }

  getSeasonTM(seasonEl, spanArrays, start, end) {

    let tm = gsap.timeline();
    tm.to(seasonEl, {opacity : 1, duration : 0, ease : 'sine.inOut'});

    let lettersTM = this.getLetterSpanTM(spanArrays);
    tm.add(lettersTM);
    tm.add("end");
    // tm.to(seasonEl,
    //       {opacity : 0, delay : .5, duration : 1, ease : 'sine.inOut'});

    let iconTM = this.getIconRowInTM(start, end);
    tm.add(iconTM, "end");
    let blowTM = this.blowAwayLetters(spanArrays);
    tm.add(blowTM, "end+=.5");
    return tm;
  }

  getIconRowInTM(start, end) {
    let iconTM = gsap.timeline();
    for (let i = start; i < end; i++) {
      let ngTM = gsap.timeline();
      ngTM.to(this.navGrid[i].material.uniforms.u_opacity,
              {value : 1.0, duration : 1, ease : 'sine.inOut'});
      ngTM.to(this.navGrid[i].material.uniforms.u_gray,
              {value : 1.0, duration : 1, ease : 'sine.inOut'}, "<");
      // ngTM.to(this.navGrid[i].scale,
      //         {x : .9, y : .9, z : .9, duration : 1, ease : 'sine.inOut'},
      //         "<");
      // ngTM.to(this.navGrid[i].scale,
      //         {x : .8, y : .8, z : .8, duration : 2, ease : 'sine.inOut'},
      //         "<+=.5");
      iconTM.add(ngTM, "<");
    }
    return iconTM;
  }

  getLetterSpanTM(spanArray) {
    let myTM = gsap.timeline();
    spanArray.forEach((item, i) => {
      myTM.to(item, {opacity : 1, duration : 1, ease : 'sine.inOut'}, "<+=.1");
    });
    return myTM;
  }

  splitLettersForSeasons() {
    let fontSize = 20;
    let seasons = document.querySelectorAll(".season");
    let spanArrays = {};

    seasons.forEach((item, i) => {
      let season = item.innerText;
      spanArrays[season] = [];
    });

    seasons.forEach((item, i) => {
      let season = item.innerText;
      let bb = item.getBoundingClientRect();
      // spanArrays[season] = [];
      let letters = item.innerText.split('');
      item.innerText = '';
      letters.forEach((letter, i) => {
        let span = document.createElement('span');
        span.innerText = letter;
        span.style.position = "absolute";
        let x = (i * fontSize) - (fontSize * 6 * .5);
        let y = 0;
        span.style.transform = "translate(" + x + "px," + y + "px)";
        spanArrays[season].push(span);
        item.appendChild(span);
      });
    });
    return spanArrays;
  }

  blowAwayLetters(spanArray) {
    let myTM = gsap.timeline();

    spanArray.forEach((item, i) => {
      myTM.to(item, {
        x : (Math.random() - .25) * 500,
        y : 200 + Math.random() * 200,
        rotation : Math.random() * 360,
        opacity : 0,
        duration : 2,
        ease : 'sine.inOut'
      },
              "<+" + (i * .1));
    });
    return myTM;
  }

  interruptAnimation() {
    if (this.playing) {
      console.log("interruptAnimation");
      this.tm.kill();
      let seasons = document.querySelectorAll(".season");
      seasons.forEach(
          (item, i) => { gsap.to(item, {opacity : 0, duration : .5}); });

      let styles = document.querySelectorAll(".poem-style");
      styles.forEach(
          (item, i) => { gsap.to(item, {opacity : 0, duration : .5}); });

      // let iconEndTm = this.getIconRowInTM(0, 16);
    }
  }
};
